<template>
  <v-card class="pa-5" flat outlined>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="facilityName"
              label="施設名"
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="dateOfWork"
              label="作業実施日"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="workResponsiblePerson"
              label="作業予定責任者"
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="1">
            <div class="text-center mt-5">印</div>
          </v-col> -->
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <v-col cols="7">
            <v-text-field
              v-model="workName"
              label="作業名"
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-text-field
              v-model="workSchedulePerson"
              label="作業予定者"
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <v-col cols="6">
            <v-container class="custom-border">
              <v-row>
                <label class="mt-8">作業サイクル</label>
              </v-row>
              <v-row>
                <v-col
                  v-for="(key, index) in monthCheckBox"
                  :key="index"
                  cols="auto"
                >
                  <v-checkbox v-model="key.check" :label="key.label" />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="6">
            <div>
              <v-text-field
                v-model="estimatedWorkTime"
                label="作業予定時間"
                outlined
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <v-col cols="6">
            <v-container class="custom-border">
              <v-row>
                <label class="mt-8">確認事項</label>
              </v-row>
              <v-row>
                <v-col
                  v-for="(key, index) in thingsCheckBox"
                  :key="index"
                  cols="auto"
                >
                  <v-checkbox v-model="key.check" :label="key.label" />
                </v-col>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="6">
            <v-container class="custom-border">
              <v-row>
                <label class="mt-8">作業予定人員</label>
              </v-row>
              <v-row>
                <v-col
                  v-for="(key, index) in estimatedWorker"
                  :key="index"
                  cols="auto"
                >
                  <div>
                    <v-text-field
                      v-model="key.value"
                      :label="key.label"
                      suffix="名"
                      outlined
                    />
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row
      ><v-container class="custom-border"
        ><div class="pt-2"><label>新2F</label></div>
        <div>
          <v-row>
            <v-col v-for="(key, index) in secondFloor" :key="index" cols="3">
              <v-checkbox v-model="key.check" :label="key.label" />
            </v-col>
          </v-row></div></v-container
    ></v-row>
    <!-- <v-spacer></v-spacer> -->
    <v-row
      ><v-container class="custom-border"
        ><div class="pt-2"><label>新3F</label></div>
        <div>
          <v-row>
            <v-col v-for="(key, index) in thirdFloor" :key="index" cols="3">
              <v-checkbox v-model="key.check" :label="key.label" />
            </v-col>
          </v-row></div></v-container
    ></v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <v-col cols="5">
            <v-container class="custom-border fill-height fill-widht">
              <v-row><label class="mt-8">作業時間</label></v-row>
              <v-row class="ma-8">
                <div>
                  <TimePicker2
                    v-model="startTime"
                    hide-details="auto"
                    close-on-complete
                    hour-label=" "
                    minute-label=" "
                    :minute-interval="15"
                  />
                </div>
                <div class="justify-center">
                  <p class="pa-2">～</p>
                </div>
                <div>
                  <TimePicker2
                    v-model="endTime"
                    hide-details="auto"
                    close-on-complete
                    hour-label=" "
                    minute-label=" "
                    :minute-interval="15"
                  />
                </div>
              </v-row>
            </v-container>
          </v-col>
          <v-col cols="7">
            <v-row>
              <v-col v-for="(key, index) in actualWorker" :key="index">
                <div>
                  <v-text-field
                    v-model="key.value"
                    :label="key.label"
                    :suffix="key.suffix"
                    outlined
                  />
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <label class="mt-8">残箇所</label>
          <!-- <v-col cols="auto"> -->
          <v-checkbox
            class="mt-7 mx-2"
            v-model="noRemainingPlace"
            label="無"
            value="無"
            @change="remainingPlace = !noRemainingPlace"
          />
          <!-- </v-col>
          <v-col cols="auto"> -->
          <v-checkbox
            class="mt-7 mx-2"
            v-model="remainingPlace"
            label="有"
            value="有"
            @change="noRemainingPlace = !remainingPlace"
          />
          <!-- </v-col> -->
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <!-- <v-row> -->

        <v-col col="12">
          <v-row>
            <label class="mt-7 mr-3">残理由</label>
            <!-- <v-row> -->
            <v-checkbox
              v-model="requestFromFacility"
              label="施設様からの要請"
              class="mr-4 mt-6"
            />
            <div>
              <v-text-field
                v-model="facilityInCharge"
                prefix="(担当者："
                suffix="様)"
                class="mr-10 mt-3"
                outlined
              />
            </div>
            <v-checkbox
              class="mt-6"
              v-model="lendingFromCompany"
              label="自社都合"
            />
            <!-- </v-row> -->
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-textarea
            name="reasonForResidual"
            hint="残理由"
            outlined
          ></v-textarea>
        </v-col>
        <!-- </v-row> -->
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <label class="mt-8">処理予定</label>
          <v-col
            v-for="(key, index) in scheduleToProcess"
            :key="index"
            cols="auto"
          >
            <v-checkbox v-model="key.check" :label="key.label" />
          </v-col>
          <!-- <label class="mt-8">(担当者：</label> -->
          <!-- <v-col cols="auto"> -->
          <v-col>
            <div>
              <v-text-field
                v-model="personInCharge"
                prefix="(担当者："
                suffix="様)"
                outlined
              />
            </div>
          </v-col>
          <!-- </v-col> -->
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-container class="custom-border">
        <v-row>
          <label class="mt-8">変更内容</label>
          <v-col v-for="(key, index) in changing" :key="index" cols="auto">
            <v-checkbox v-model="key.check" :label="key.label" />
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <!-- <v-spacer></v-spacer> -->
    <v-row>
      <v-container class="custom-border">
        <v-textarea name="locationChange" label="変更場所"></v-textarea>
        <v-text-field v-model="locationChangeReason" label="理由" />
      </v-container>
    </v-row>
    <!-- <v-spacer></v-spacer> -->
    <v-row>
      <v-container class="custom-border">
        <v-textarea
          class="mt-3"
          name="additionalLocations"
          label="追加場所"
        ></v-textarea>

        <v-text-field v-model="additionalLocationsReason" label="理由" />
      </v-container>
    </v-row>
    <!-- <v-spacer></v-spacer> -->
    <v-row>
      <v-container class="custom-border">
        <!-- <v-col> -->
        <label class="mt-8">人員変更</label>
        <!-- </v-col>
        <v-col> -->
        <div>
          <v-text-field v-model="personelChange" label="変更内容" />
        </div>
        <!-- </v-col> -->
        <!-- <v-col> -->
        <div>
          <v-text-field v-model="personelChangeReason" label="理由" />
        </div>
        <!-- </v-col> -->
      </v-container>
    </v-row>
    <!-- <v-spacer></v-spacer> -->
    <v-row>
      <v-textarea name="remarks" label="備考" outlined></v-textarea>
    </v-row>
    <v-row>
      <div class="custom-border">
        <div>
          <VueSignaturePad
            width="500px"
            height="250px"
            ref="signaturePad"
            id="signature"
            :options="options"
          />
        </div>
        <v-spacer></v-spacer>
        <div class="py-5 d-flex justify-center">
          <v-btn color="error" @click="undo">Clear</v-btn>
        </div>
      </div>
    </v-row>
    <v-card-actions class="pt-8">
      <v-spacer></v-spacer>
      <Btn color="success" @click="click()">完了</Btn>
    </v-card-actions>
  </v-card>
</template>
<script>
// mixins
import Common from "@/mixins/common";
import ShowDialogs from "@/mixins/showDialogs";
// VueGoodTable
import "vue-good-table/dist/vue-good-table.css";

import Api from "@/mixins/api";
import TimePicker2 from "../components/TimePicker2.vue";
import { VueSignaturePad } from "vue-signature-pad";

export default {
  name: "TeikiSagyoReport",
  mixins: [Common, ShowDialogs, Api, TimePicker2],
  components: { VueSignaturePad },
  data: () => ({
    facilityName: "徳洲会 松原徳洲会",
    dateOfWork: "2025年03月12日",
    workResponsiblePerson: "",
    workName: "フイルター掃",
    workSchedulePerson: "",
    estimatedWorkTime: "9:00～15:30(2名)",
    startTime: "",
    endTime: "",
    requestFromFacility: false,
    facilityInCharge: "",
    lendingFromCompany: false,
    personInCharge: "",
    locationChangeReason: "",
    personelChangeReason: "",
    additionalLocationsReason: "",
    personelChange: "",
    noRemainingPlace: "",
    remainingPlace: "",
    options: {
      penColor: "#F44336"
    },
    monthCheckBox: [
      {
        label: "1ヶ月",
        check: false
      },
      {
        label: "2ヶ月",
        check: false
      },
      {
        label: "3ヶ月",
        check: false
      },
      {
        label: "4ヶ月",
        check: false
      },
      {
        label: "6ヶ月",
        check: false
      },
      {
        label: "12ヶ月",
        check: false
      }
    ],
    thingsCheckBox: [
      {
        label: "作業前あいさつ",
        check: false
      },
      {
        label: "安全確認",
        check: false
      },
      {
        label: "表示板",
        check: false
      },
      {
        label: "コーン＋チェーン",
        check: false
      },
      {
        label: "その他（　　　　　　              　　　）",
        check: false
      }
    ],
    estimatedWorker: [
      {
        label: "1日",
        value: 1
      },
      {
        label: "ア",
        value: 3
      },
      {
        label: "オ",
        value: 4
      }
    ],
    actualWorker: [
      {
        label: "実働",
        value: 1,
        suffix: "H"
      },
      {
        label: "休憩時間",
        value: 1,
        suffix: "H"
      },
      {
        label: "作業人数",
        value: 1,
        suffix: "名"
      },
      {
        label: "ア",
        value: 3,
        suffix: "名"
      },
      {
        label: "オ",
        value: 4,
        suffix: "名"
      }
    ],
    remainingParts: [
      {
        label: "無",
        check: true
      },
      {
        label: "有",
        check: false
      }
    ],
    secondFloor: [
      {
        label: "A",
        check: false
      },
      {
        label: "B",
        check: false
      },
      {
        label: "C",
        check: false
      },
      {
        label: "D",
        check: false
      },
      {
        label: "E",
        check: false
      }
    ],
    thirdFloor: [
      {
        label: "EVホール",
        check: false
      },
      {
        label: "EVホール1",
        check: false
      },
      {
        label: "EVホール2",
        check: false
      },
      {
        label: "EVホール3",
        check: false
      },
      {
        label: "EVホール3",
        check: false
      },
      {
        label: "EVホール4",
        check: false
      },
      {
        label: "EVホール5",
        check: false
      },
      {
        label: "EVホール6",
        check: false
      }
    ],
    scheduleToProcess: [
      {
        label: "次月対応",
        check: false
      },
      {
        label: "日程検討",
        check: false
      },
      {
        label: "次回サイクル対応",
        check: false
      }
    ],
    changing: [
      {
        label: "変更",
        check: false
      },
      {
        label: "追加（契約内）※月サイクル分",
        check: false
      },
      {
        label: "追加（契約外）※スポット対応",
        check: false
      }
    ],
    actualWorkTime: "08:30"
  }),
  computed: {},
  methods: {
    undo() {
      console.log("undo");
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
    },
    change() {
      this.options = {
        penColor: "#00f"
      };
    },
    resume() {
      this.options = {
        penColor: "#c0f"
      };
    },
    async click() {
      console.log("click");
      this.$info("登録されました。");
    }
  },
  mounted() {
    console.log("mounted");
  },
  async created() {
    console.log("created");
  }
};
</script>

<style lang="scss" scoped>
#signature {
  border: double 2px transparent;
  //border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #c4b9b9, #c4b9b9);
  background-origin: border-box;
  background-clip: content-box, border-box;
  //#94ce0e
  //#989b93
}
.container {
  width: "100%";
  padding: 8px 16px;
}
.buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
.custom-border {
  border: 1px solid #c4b9b9; /* Green border */
  //padding: 10px 0;
  //border-radius: 8px; /* Optional rounded corners */
}
</style>
